/*
 * Which section of a settings page the Member is reading, kept apart from the AnchorNav that shows
 * it so the rule can be checked without a browser.
 */

/**
 * The section an AnchorNav marks as current. `showing` holds the sections now crossing the band
 * just under the page's chrome, and the first of those, in page order, is the one being read. At
 * the very bottom of the page the last section is current, even when it is too short ever to
 * reach the band. With nothing in the band, as when scrolling across a gap between two sections,
 * the previous answer stands.
 */
export function currentAnchor(
  ids: readonly string[],
  showing: ReadonlySet<string>,
  atBottom: boolean,
  previous: string | undefined,
) {
  if (atBottom && ids.length > 0) return ids[ids.length - 1]
  return ids.find((id) => showing.has(id)) ?? previous ?? ids[0]
}
